import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigCropset } from 'app/interfaces/publication';
import { ReplaySubject } from 'rxjs';
import { PublicationService } from './publication.service';

export interface BBAspectRatio extends ConfigCropset {
	value: string; // 21:9, for e.g. channels to use
	custom: boolean; // false if in default cropsets
}

@Injectable()
export class AspectRatioService {
	public aspectRatioRef: { [key: string]: BBAspectRatio } = {}; // lookup by object key '1:1', '16:9' etc
	public aspectRatioRefName: { [key: string]: BBAspectRatio } = {}; // lookup by object key 'landscape', 'portrait', etc
	public aspectRatios: BBAspectRatio[] = [];

	public aspectRatiosObs = new ReplaySubject<BBAspectRatio[]>(1);

	private activeCropsets: ConfigCropset[] = [];
	private standardCropsets: ConfigCropset[] = [];

	constructor(
		private translate: TranslateService,
		private publicationService: PublicationService
	) {
		this.init();
	}

	init(): void {
		this.publicationService.publicationConfigObs.subscribe((config) => {
			this.activeCropsets = config.cropsets;
			this.standardCropsets = config.standardCropsets;
			this.setAspectRatios();
		});
	}

	public getAspectRatioByName(name: string): BBAspectRatio | undefined {
		return this.aspectRatios.find(ar => ar.name === name);
	}

	private setAspectRatios(): void {
		this.aspectRatios = (this.activeCropsets as BBAspectRatio[])
			.sort((a, b) => b.aspectratio - a.aspectratio)
			.map(set => {
				if (this.standardCropsets?.some(standard => standard.name === set.name)) {
					// translate standard labels
					set.label = this.translate.instant(set.label);
					set.custom = false;
				} else {
					set.custom = true;
				}

				if (set.aspectwidth && set.aspectheight) {
					set.value = `${set.aspectwidth}:${set.aspectheight}`; // value for playouts, e.g. '16:9'
				} else {
					set.value = null; // default set
				}
				this.aspectRatioRef[set.value] = set;
				this.aspectRatioRefName[set.name] = set;
				return set;
			});

		this.aspectRatiosObs.next(this.aspectRatios);
	}
}
